import * as Yup from "yup";

const SKU = {
  sku: Yup.string().notRequired().max(12),
};

export const PRODUCTS_FORMS_RULES = {
  SKU: Yup.object().shape(SKU),
};
